/**
 * Job 進度 SSE 訂閱（GET /api/model-endpoints/jobs/{id}/events）。
 *
 * 後端行為（model_endpoints/router.py §3.5）：attach 即得當前快照、之後即時事件、
 * 15s heartbeat（comment 行,EventSource 自動忽略）;斷線只解除訂閱不中止 job。
 * 因此 onError 時呼叫端應改用 GET /jobs/{id} 輪詢收尾,不需重連邏輯。
 */

import type { JobSnapshot } from '@/api/modelEndpoints';

export interface JobSubscription {
  /** 關閉連線（元件 unmount / 進終態後呼叫）。 */
  close: () => void;
}

export function subscribeJobEvents(
  jobId: string,
  onEvent: (snapshot: JobSnapshot) => void,
  onError?: () => void,
): JobSubscription {
  const es = new EventSource(
    `/api/model-endpoints/jobs/${encodeURIComponent(jobId)}/events`,
    { withCredentials: true },
  );
  es.onmessage = (e) => {
    try {
      onEvent(JSON.parse(e.data) as JobSnapshot);
    } catch {
      // 非 JSON（不應發生）→ 忽略該筆
    }
  };
  es.onerror = () => {
    es.close();
    onError?.();
  };
  return { close: () => es.close() };
}
